import React, { FC } from 'react'

import * as S from './ActionLinks.styles'
import { ActionItemProps } from './ActionLinks.types'

const ActionLinkItem: FC<ActionItemProps> = ({
  label,
  action,
  actionPending,
  isDisabled,
  dataCy,
  shouldHighLightLink = false,
}: ActionItemProps) => {
  return (
    <S.ActionLink
      isDisabled={isDisabled}
      isLoading={actionPending}
      data-cy={dataCy}
      {...(!isDisabled && { onClick: action })}
    >
      <S.ActionLinkContent shouldHighLightLink={shouldHighLightLink} isDisabled={isDisabled}>
        {label}
      </S.ActionLinkContent>
    </S.ActionLink>
  )
}

export { ActionLinkItem }
